module.exports = __webpack_public_path__ + "static/assets/e1b95f47ec3de1fea3c6f1de16c39579.svg";